import React, { Component } from "react";
import { connect } from "react-redux";
import { Row, Col, Form, FormGroup, Alert } from "react-bootstrap";
import { Field, reduxForm, formValueSelector } from "redux-form";
import _ from "lodash";
import moment from "moment";
import Accordion from "../../../../employer/project/components/Accordion";
import Button from "../../../../../components/common/button/Button";
import Input from "../../../../../components/common/input/Input";
import Select2 from "../../../../../components/common/select/Select2";
import Typeahead from "../../../../../components/common/typeahead/Typeahead";
import {
  required,
  date,
  dropdown,
  minNumber,
  comma,
  floatWithComma
} from "../../../../../utils/forms/validators";
import RichEditor from "../../../../../components/common/richEditor/RichEditor";
import { getProject } from "../../../../../actions/admin.actions";
import ScrollToTopOnMount from "../../../../../utils/scroll/ScrollToTopOnMount";
import DatePicker2 from "./DatePicker2";
import styles from "./EditProjectDetail.scss";

const richEditorValidation = (max, msg) => value => {
  const valueParse = value
    ? value.replace(/<[^>]*>/g, "").replace("&nbsp;", " ")
    : "";
  return valueParse.length > max && msg;
};

const overview = richEditorValidation(
  1001,
  "Overview must be less than or equal to 1000 characters."
);

const responsibilities = richEditorValidation(
  2501,
  "Responsabilities must be less than or equal to 2500 characters."
);

const rateFloat = floatWithComma("Please enter a valid number.");
const rateMin = minNumber(50, "Please enter a valid number");
const dateVal = date("Please enter a valid Date.");
const rateTypeVal = dropdown("Please select a Rate Type.");
const rateComma = comma("Please enter numeric characters only");

const RATE_TYPE_UNSELECTED = -1;
const RATE_TYPE_HOURLY = 74;
const RATE_TYPE_DAILY = 75;
const RATE_TYPE_WEEKLY = 76;
const RATE_TYPE_MONTHLY = 77;
const RATE_TYPE_NEGOTIABLE = 78;

class EditProjectDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      rate: null,
      startDate: null,
      categoriesChecked: [],
      defaultValueRadio: ""
    };

    this.handleChangeRadio = this.handleChangeRadio.bind(this);
    this.handleRateChange = this.handleRateChange.bind(this);
    this.handleStartDateChange = this.handleStartDateChange.bind(this);
    this.validateCheckbox = this.validateCheckbox.bind(this);
  }

  componentMount() {
    this.props.getProject(this.props.projectId);
    this.handleStartDateChange(moment());
  }

  handleSelect() {
    this.props.change("budget_rate_value", null);
    this.props.change("budget_rate_period", null);
  }

  handleRateChange(event) {
    const value = _.toNumber(event.target.value);
    this.setState({ rate: value });
  }

  handleStartDateChange(value) {
    this.setState({ startDate: moment(value) });
  }

  handleChangeRadio(event, value, pVal, callback) {
    callback();
  }

  validateCheckbox(value, index, count, callback) {
    this.setState(prevState => {
      const existItem = [...prevState.categoriesChecked].find(
        item => item.index === index
      );
      let newcategoriesChecked;
      if (!existItem) {
        newcategoriesChecked = [...prevState.categoriesChecked, { index }];
      } else {
        if (count) {
          newcategoriesChecked = [...prevState.categoriesChecked];
        } else {
          newcategoriesChecked = [...prevState.categoriesChecked].filter(
            item => item.index !== index
          );
        }
      }
      if (!_.isEmpty(this.props.formValues.skills)) {
        this.setState(
          {
            categoriesChecked: newcategoriesChecked,
            defaultValueRadio: ""
          },
          () => {
            callback();
          }
        );
      }
    });
  }

  renderRateField() {
    // Negotiable
    if (
      !this.props.rateType ||
      this.props.rateType == RATE_TYPE_UNSELECTED ||
      this.props.rateType == RATE_TYPE_NEGOTIABLE
    )
      return null;

    // Other
    return (
      <Field
        name="budget_rate_value"
        type="text"
        placeholder="$ Rate"
        component={Input}
        onChange={e => this.handleRateChange(e)}
        validate={[required, rateComma, rateFloat, rateMin]}
      />
    );
  }

  renderRatePeriodField() {
    if (!this.props.rateType || this.props.rateType == RATE_TYPE_UNSELECTED)
      return null;

    // Hourly || Daily
    if (
      this.props.rateType == RATE_TYPE_HOURLY ||
      this.props.rateType == RATE_TYPE_DAILY ||
      this.props.rateType == RATE_TYPE_WEEKLY ||
      this.props.rateType == RATE_TYPE_MONTHLY
    ) {
      const placeholder =
        this.props.rateType == RATE_TYPE_DAILY
          ? "Est. Days/Week"
          : "Est. Hours/Week";
      /*let type = 'd/w';
      if (this.props.rateType == RATE_TYPE_HOURLY ||
        this.props.rateType == RATE_TYPE_WEEKLY ||
        this.props.rateType == RATE_TYPE_MONTHLY ) type = 'h/w';*/
      return (
        <Field
          formGroupClassName={
            this.props.rateType == RATE_TYPE_HOURLY && styles.hoursInput
          }
          name="budget_rate_period"
          type="text"
          placeholder={placeholder}
          component={Input}
          //validate={ type === 'h/w' ? [required, hours] : [required, week, numericWeek]}
        />
      );
    }
    return null;
  }

  render() {
    const {
      submitting,
      valid,
      cities,
      onSearchCities,
      isLoading,
      initialValues
    } = this.props;

    let selectedArray = new Array(7).fill(0);
    if (_.get(initialValues, "must_skills")) {
      initialValues.must_skills.forEach(skill => {
        selectedArray[skill.description.category_id - 1] += 1;
      });
    }
    if (_.get(initialValues, "nice_skills")) {
      initialValues.nice_skills.forEach(skill => {
        selectedArray[skill.description.category_id - 1] += 1;
      });
    }

    const selectedCityProps = {};
    if (this.props.defaultLocation) {
      selectedCityProps.selected = [this.props.defaultLocation];
    }

    // Dropdown status options
    const currentStatus = initialValues.status_id;

    let status = this.props.status.filter(
      status => status.id === currentStatus
    );

    switch (currentStatus) {
      case 1:
        status = this.props.status.filter(
          status => status.id === 2 || status.id === currentStatus
        );
        break;
      case 6:
        status = this.props.status.filter(
          status => status.id === 5 || status.id === currentStatus
        );
        break;
      case 8:
        status = this.props.status.filter(
          status => status.id === 6 || status.id === currentStatus
        );
        break;
      case 9:
        status = this.props.status.filter(
          status => status.id === 8 || status.id === currentStatus
        );
        break;
      case 12:
      case 13:
        status = this.props.status.filter(
          status => status.id === 9 || status.id === currentStatus
        );
        break;
    }

    return (
      <section>
        <ScrollToTopOnMount />
        <section className={styles.editProjectDetail}>
          <div className={styles.content}>
            <Form onSubmit={this.props.handleSubmit}>
              <h2 className={styles.title}>Project Basics</h2>

              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.sectionTitle}>Admin</div>

                  <Row>
                    <Col md={6} xs={6}>
                      <Field
                        name="admin_id"
                        type="select"
                        placeholder="Admins..."
                        component={Select2}
                        options={this.props.admins}
                        valueKey="id"
                        labelKey="name"
                      />
                    </Col>
                  </Row>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Status</div>

                  <Row>
                    <Col md={6} xs={6}>
                      <Field
                        name="status_id"
                        type="select"
                        placeholder="Status"
                        component={Select2}
                        options={status}
                        valueKey="id"
                        labelKey="value"
                      />
                    </Col>
                  </Row>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Title</div>
                  <div className={styles.sectionDescription}>
                    E.g. VP of Marketing, Chief Financial Officer, Creative
                    Director
                  </div>

                  <Row>
                    <Col md={6} xs={6}>
                      <Field
                        name="title"
                        type="text"
                        placeholder="Project Title"
                        component={Input}
                        validate={required}
                      />
                    </Col>
                  </Row>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Overview</div>
                  <div className={styles.sectionDescription}>
                    First impressions are everything. Members will see dozens of
                    Projects in their inbox, so make this exciting enough that
                    they’ll send you a great pitch.
                  </div>

                  <Field
                    name="overview"
                    component={RichEditor}
                    //help='500 characters max'
                    maxLength={1001}
                    validate={overview}
                  />

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>
                    Responsibilities + Deliverables
                  </div>
                  <div className={styles.sectionDescription}>
                    Here's where to get specific on the exact tasks you'll want
                    the member to perform. The more specific you are, the better
                    your pitches will be.
                  </div>

                  <Field
                    name="responsibilities"
                    component={RichEditor}
                    //help='1,100 characters max'
                    maxLength={2501}
                    validate={responsibilities}
                  />

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Location</div>

                  <Row>
                    <Col md={6} xs={6}>
                      <Field
                        name="city"
                        placeholder="Office Location (City, State)"
                        component={Typeahead}
                        onSearch={query => onSearchCities(query)}
                        isLoading={isLoading || false}
                        options={cities}
                        isAsync={true}
                        minLength={3}
                        allowNew={false}
                        labelKey="description"
                        valueKey="id"
                        icon="map-marker"
                        validate={required}
                        {...selectedCityProps}
                      />
                    </Col>
                    <Col md={6} xs={6}>
                      <Field
                        name="work_type_id"
                        type="select"
                        placeholder="Work From..."
                        component={Select2}
                        options={this.props.workTypes}
                        valueKey="id"
                        labelKey="value"
                      />
                    </Col>
                  </Row>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Job Type</div>

                  <Row>
                    <Col md={6} xs={6}>
                      <Field
                        name="job_type_id"
                        type="select"
                        placeholder="Job Type"
                        component={Select2}
                        options={this.props.jobTypes}
                        valueKey="id"
                        labelKey="value"
                      />
                    </Col>
                  </Row>

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>Company Budget</div>

                  <Row>
                    <Col md={6} xs={6}>
                      <Field
                        name="company_budget_id"
                        type="select"
                        placeholder="Company Budget"
                        component={Select2}
                        options={this.props.companyBudgets}
                        valueKey="id"
                        labelKey="value"
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </div>

              <h2 className={styles.title}>Categories + Skills</h2>

              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.accordion}>
                    {this.props.skills &&
                      this.props.skills.map((el, index) => (
                        <Accordion
                          category={
                            this.props.formValues &&
                            this.props.formValues.category_id
                          }
                          key={el.id}
                          selectedSkills={this.props.formValues.skills}
                          selectedNumber={selectedArray[index]}
                          name={el.name}
                          onChangeRadio={this.handleChangeRadio}
                          handleCheck={(value, count, callback) =>
                            this.validateCheckbox(value, index, count, callback)
                          }
                          defaultValueRadio={this.state.defaultValueRadio}
                          submitting={this.props.isSubmitting}
                          {...el}
                        />
                      ))}
                  </div>
                </FormGroup>
              </div>

              <h2 className={styles.title}>Budgeting</h2>

              <div className={styles.form}>
                <FormGroup>
                  <div className={styles.sectionTitle}>Budget</div>

                  <Row>
                    <Col md={4} xs={4}>
                      <Field
                        name="budget_rate_type_id"
                        type="select"
                        placeholder="Rate Type"
                        component={Select2}
                        options={this.props.projectBudgetRateTypes}
                        onChange={() => this.handleSelect()}
                        validate={[required, rateTypeVal]}
                      />
                    </Col>
                    <Col md={4} xs={4}>
                      {this.renderRateField()}
                    </Col>
                    <Col md={4} xs={4}>
                      {this.renderRatePeriodField()}
                    </Col>
                  </Row>

                  {(this.state.rate && this.state.rate < 50) ||
                  this.state.rate === 0 ? (
                    <Row>
                      <br />
                      <Alert bsStyle="danger" className={styles.budgetError}>
                        Our members typically charge a minimum of $50/hour. We
                        suggest you enter a higher rate, select a project rate
                        or choose "Negotiable" to proceed.
                      </Alert>
                    </Row>
                  ) : null}

                  <div className={styles.divider} />

                  <div className={styles.sectionTitle}>
                    Project Run (Optional)
                  </div>

                  <Row>
                    <Col md={4} xs={4}>
                      <Field
                        name="budget_run_start"
                        placeholder="Start"
                        component={DatePicker2}
                        minDate={moment()}
                        onSelectDate={this.handleStartDateChange}
                        validate={dateVal}
                      />
                    </Col>
                    <Col md={4} xs={4}>
                      <Field
                        name="budget_run_end"
                        placeholder="End"
                        component={DatePicker2}
                        minDate={this.state.startDate}
                        validate={dateVal}
                      />
                    </Col>
                  </Row>
                </FormGroup>

                <div className={styles.dividerDouble} />

                <div className={styles.CTAContainer}>
                  <Button
                    isPrimary
                    type="submit"
                    size={"large"}
                    label="Save + Go Back"
                    isDisabled={!valid || submitting}
                  />
                </div>
              </div>
            </Form>
          </div>
        </section>
      </section>
    );
  }
}

EditProjectDetail = reduxForm({
  form: "adminProjectDetail",
  enableReinitialize: true
})(EditProjectDetail);

const selector = formValueSelector("adminProjectDetail");
EditProjectDetail = connect(
  state => {
    const defaultLocation = selector(state, "city");
    const rateType = selector(state, "budget_rate_type_id");
    return {
      defaultLocation,
      rateType,
      initialValues: state.admin.project,
      isSubmitting: state.project.isSubmitting
    };
  },
  dispatch => {
    return {
      getProject: id => dispatch(getProject(id))
    };
  }
)(EditProjectDetail);

export default EditProjectDetail;



// WEBPACK FOOTER //
// ./src/routes/admin/project/edit/components/EditProjectDetail.js